import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface InfoField {
  key: string;
  label: string;
  value: string | number | null | undefined;
  icon?: LucideIcon;
  colSpan?: 1 | 2 | 3 | 4;
  highlight?: boolean;
}

interface ShipmentInfoGridProps {
  fields: InfoField[];
  columns?: 2 | 3 | 4;
  className?: string;
}

export function ShipmentInfoGrid({ 
  fields, 
  columns = 4,
  className 
}: ShipmentInfoGridProps) {
  const gridCols = {
    2: 'grid-cols-1 sm:grid-cols-2',
    3: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4',
  };

  const colSpanClasses = {
    1: '',
    2: 'sm:col-span-2',
    3: 'sm:col-span-2 lg:col-span-3',
    4: 'sm:col-span-2 lg:col-span-4',
  };

  return (
    <div className={cn("grid gap-4", gridCols[columns], className)}>
      {fields.map((field) => (
        <div
          key={field.key}
          className={cn(
            "flex flex-col gap-1 p-3 rounded-lg bg-muted/50",
            colSpanClasses[field.colSpan || 1],
            field.highlight && "bg-primary/10 border border-primary/20"
          )}
        >
          <span className="text-sm text-muted-foreground flex items-center gap-1.5">
            {field.icon && <field.icon className="h-3.5 w-3.5" />}
            {field.label}
          </span>
          <span className={cn(
            "text-sm font-medium",
            field.highlight && "text-primary"
          )}>
            {field.value ?? '-'}
          </span>
        </div>
      ))}
    </div>
  );
}
